import { useContext } from 'react';

import { NavigationContext } from '@layout/navigation/navigation';

import { TasksQuery } from './Tasks.query';

const Tasks = () => {
  const { isSuperAdmin } = useContext(NavigationContext);

  if (!isSuperAdmin) {
    return <div />;
  }

  return <TasksQuery />;
};

export { Tasks };
